export default __webpack_public_path__ + "static/media/peaches.addb0d7b.webp";